import { CalenderEventFieldsFragment } from '__generated__/graphql';

import { EventHeader, EventInfo } from '../../common/Common/EventHeader';
import { resizedImageUrl } from '../../common/helpers';
import UI from '../../common/UI';
import useLocale from '../../common/useLocale';

interface EventCardProps {
  event: CalenderEventFieldsFragment;
}

export const EventCard = ({ event }: EventCardProps) => {
  const { locale } = useLocale();

  return (
    <UI.NavCard
      href={`${event.checkout_url}?locale=${locale}`}
      sc={{ hasPanels: true, spacing: 'sm', flex: { direction: 'column', alignItems: 'space-between' } }}
      title={event.title}
    >
      <UI.Div style={{ padding: 0, margin: -1, overflow: 'hidden' }}>
        <EventHeader
          headerUrl={event.header_url}
          size={900}
          sportType={event.sport_types[0]}
          sc={{ padding: 0, borderRadius: 'none' }}
          color={event.brand_color}
          alt={event.title}
        />
      </UI.Div>
      <UI.GridContainer
        sc={{
          columns: event.logo_url ? '64px 1fr' : '1fr',
          gutter: 0.5,
        }}
      >
        {event.logo_url && (
          <UI.Div>
            <UI.ProfilePic
              sc={{ background: 'white', size: 64 }}
            >
              <img src={resizedImageUrl(event.logo_url, 300, 'webp')} alt={event.title} />
            </UI.ProfilePic>
          </UI.Div>
        )}
        <UI.Div style={{ minWidth: 0 }}>
          <UI.H3 sc={{ fontSize: 3, my: 0.25 }} style={{ fontWeight: 700 }}>
            <UI.Truncate>
              {event.title}
            </UI.Truncate>
          </UI.H3>
          <EventInfo
            event={{
              ...event,
              location: {
                ...event.location,
                id: null,
              },
            }}
            direction="column"
          />
        </UI.Div>
      </UI.GridContainer>
    </UI.NavCard>
  );
};

export default undefined;
